var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Cập nhật cấu hình",
            visible: _vm.isUpdateOneKidsConfigDialog,
            width: "800px",
            "before-close": _vm.handleClose,
            top: "5vh",
            close: _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isUpdateOneKidsConfigDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên cấu hình", prop: "configName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formData.configName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "configName", $$v)
                      },
                      expression: "formData.configName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tên biến", prop: "variableName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formData.variableName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "variableName", $$v)
                      },
                      expression: "formData.variableName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Mô tả chức năng", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 4 },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Chọn chức năng", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Chọn chức năng",
                      },
                      model: {
                        value: _vm.formData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "type", $$v)
                        },
                        expression: "formData.type",
                      },
                    },
                    _vm._l(_vm.configTypeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Chọn kiểu dữ liệu", prop: "dataType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Chọn kiểu dữ liệu",
                      },
                      model: {
                        value: _vm.formData.dataType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "dataType", $$v)
                        },
                        expression: "formData.dataType",
                      },
                    },
                    _vm._l(_vm.dataTypeList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Giá trị", prop: "value" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formData.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "value", $$v)
                      },
                      expression: "formData.value",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    loading: _vm.loading,
                    size: "medium",
                    type: "success",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleUpload()
                    },
                  },
                },
                [_vm._v("\n        Lưu\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: { click: _vm.handleClose },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }